const isInternalLink = (url?: string): boolean => {
    if (!url) return false;
    return !url?.includes('http') || url?.includes('jochen-schweizer') || url?.includes('mydays');
};

export { isInternalLink };
